
function createDropdownItem(country) {
    // ...
    var item = document.createElement("a");
    var item = document.createElement("a");
    var img = document.createElement("img");
    img.src = country.flagUrl; 
    img.alt = country.name + " flag";
    img.classList.add("d-inline-block", "align-top");
    img.width = "16";
    img.height = "16";
    item.appendChild(img);
    var textNode = document.createTextNode(" " + country.name);
    item.appendChild(textNode);
    item.href = country.link || "#";
    item.className = "dropdown-item";
    return item;
}

function createHeaderTopBar(currentCountry, countries, topBarLinks) {
    // ...
    var header = document.createElement("section");
    header.id = "header-top-bar";
    header.className = "flex-container d-none d-md-block";

    var countryDropdown = document.createElement("div");
    countryDropdown.id = "country-dropdown-wrapper";
    var countryButton = document.createElement("button");
    countryButton.id = "dropdown-country";
    countryButton.className = "dropdown-toggle btn btn-link";
    countryButton.type = "button";

    var img = document.createElement("img"); // Create an image element
    img.src = currentCountry.flagUrl;
    img.alt = currentCountry.name + " Flag";
    img.srcset = currentCountry.flagUrl;
    img.sizes = "(max-width: 767px) 16px, 16px";
    img.decoding = "async";
    img.width = "16";
    img.height = "16";
    img.classList.add("d-inline-block", "align-top");

    countryButton.appendChild(img); // Append the image to the button
    countryButton.appendChild(document.createTextNode(" " + currentCountry.name));
    var dropdownArrow = document.createElement("span");
    dropdownArrow.className = "dropdown-arrow";
    dropdownArrow.textContent = " ⏷";
    countryButton.appendChild(dropdownArrow);

    countryButton.onclick = function () {
        var menu = document.querySelector(
            "#country-dropdown-wrapper .dropdown-menu"
        );
        menu.style.display = menu.style.display === "block" ? "none" : "block";
    };
    countryDropdown.appendChild(countryButton);

    var countryMenu = document.createElement("div");
    countryMenu.className = "dropdown-menu";
    countryMenu.style.display = "none"; // Hide menu by default
    countries.forEach(function (country) {
        if (country.name !== currentCountry.name) {
            countryMenu.appendChild(createDropdownItem(country));
        }
    });
    countryDropdown.appendChild(countryMenu);
    header.appendChild(countryDropdown);

    var linksList = document.createElement("ul");
    linksList.className = "header-top-links";
    topBarLinks.forEach(function (link) {
        var listItem = document.createElement("li");
        var anchor = document.createElement("a");
        anchor.href = link.link;
        anchor.textContent = link.name;
        listItem.appendChild(anchor);
        linksList.appendChild(listItem);
    });
    header.appendChild(linksList);

    return header;
}

document.addEventListener("DOMContentLoaded", function () {
    var USButton = document.getElementById('USButton');
    var dropdownMenu = document.getElementById('dropdownMenu');

    USButton.addEventListener('click', function () {
        var displayStyle = dropdownMenu.style.display;
        dropdownMenu.style.display = displayStyle === 'none' ? 'block' : 'none';
    });
    var currentCountry = {
        // ...
        name: "United Kingdom",
        link: "https://www.zinus.uk/",
        flagUrl:
            "https://cdn.shopify.com/s/files/1/2097/4191/files/United_Kingdom_flag.png?v=1689693534",
    };
    var countries = [
        // ...
        {
            name: "Australia",
            link: "https://www.zinus.com.au/",
            flagUrl:
                "https://cdn.shopify.com/s/files/1/2097/4191/files/Australia_flag.png?v=1689693535",
        },
        {
            name: "Canada",
            link: "https://www.zinus.ca/",
            flagUrl:
                "https://cdn.shopify.com/s/files/1/2097/4191/files/Canada_flag.png?v=1689693534",
        },
        {
            name: "France",
            link: "https://www.zinus.fr/",
            flagUrl:
                "https://cdn.shopify.com/s/files/1/2097/4191/files/France_flag.png?v=1689693535",
        },
        {
            name: "Germany",
            link: "https://www.zinus.com.de/",
            flagUrl:
                "https://cdn.shopify.com/s/files/1/2097/4191/files/Germany_flag.png?v=1689693535",
        },
        {
            name: "Indonesia",
            link: "https://zinus.co.id/",
            flagUrl:
                "https://cdn.shopify.com/s/files/1/2097/4191/files/Indonesia_flag.png?v=1689693535",
        },
        {
            name: "Japan",
            link: "https://zinus.jp/",
            flagUrl:
                "https://cdn.shopify.com/s/files/1/2097/4191/files/Japan_flag.png?v=1689693534",
        },
        {
            name: "United States",
            link: "http://www.zinus.com",
            flagUrl:
                "https://cdn.shopify.com/s/files/1/2097/4191/files/United_States_flag.png?v=1689693535",
        },
        {
            name: "Italy",
            link: "https://www.zinus.it/",
            flagUrl:
                "https://cdn.shopify.com/s/files/1/2097/4191/files/Italy.png?v=1692389350",
        },
        {
            name: "Spain",
            link: "https://www.zinus.es/",
            flagUrl:
                "https://cdn.shopify.com/s/files/1/2097/4191/files/spain.png?v=1692389388",
        },
    ];
    var topBarLinks = [
        // ...
        { name: "", link: "" },
        { name: "", link: "" },
        { name: "", link: "" },
    ];

    var headerTopBar = createHeaderTopBar(currentCountry, countries, topBarLinks);

    var existingHeader = document.getElementById("header-top-bar");
    existingHeader.parentNode.replaceChild(headerTopBar, existingHeader);
});
